import script from "./SurveyFiles.vue?vue&type=script&setup=true&lang=ts"
export * from "./SurveyFiles.vue?vue&type=script&setup=true&lang=ts"

import "./SurveyFiles.vue?vue&type=style&index=0&id=4819882f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4819882f"]])

export default __exports__